const env = process.env.REACT_APP_NODE_ENV;

const apiConfig = {
  dev: {
    API_BASE: 'https://backendlogitrackprod.azurewebsites.net',
   //PROD API_BASE: 'https://backendlogitrackprod.azurewebsites.net',
   //PROD URL_AMBIENTE : 'https://emin.logitrack.app',
   //QA API_BASE: 'https://slmserver-production.up.railway.app',
  //  API_BASE: 'http://localhost:5000',
  //QA URL_AMBIENTE : 'https://eminqa.logitrack.app',
   URL_AMBIENTE : 'https://emin.logitrack.app',
  },
  prod: {
    API_BASE: 'https://server-production-a29c.up.railway.app',
  },
  testing: {
    API_BASE: 'https://server-production-a29c.up.railway.app',
  },
  env,
};

export default apiConfig;